/*eslint no-undef: "error"*/
/*eslint complexity: ["error", 10]*/
/*eslint max-depth: ["error", 7]*/
/*eslint max-len: ["error", { "ignoreStrings": true, "code": 170, "tabWidth": 9 }]*/
/*eslint max-lines-per-function: ["error", {"max": 41, "skipComments": true}]*/
/*eslint max-nested-callbacks: ["error", 3]*/
/*eslint max-params: ["error", 10]*/
/*eslint max-statements: ["error", 20]*/
/*eslint-env es6*/
/*eslint max-lines-per-function: ["error", 150]*/

const form_lead_interesse = ( function () {

    const moduloId = '#form-lead-interesse';

    // WP AJAX
    const WP_AJAX_RESPONSE_TYPE = 'json';
    const WP_AJAX_METHOD = 'POST';
    const WP_AJAX_ROUTE = $(`${moduloId} form`).data('adminajax');
    const WP_AJAX_ACTION = 'save_apipravaler_leadproposta';

    // REGEX CONFIGS
    const REGEXP_CLEAR_NUMBERS = /[^0-9]/g;
    const REGEXP_NAME_FULL = /^\S+(\s\S+)+$/;
    const REGEXP_EMAIL = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    const init = () => {
        activeLabelsAndFields();
        apply_jquery_mask();
        apply_click_out_bubble();
        on_form_submit();
        form_load();
        nav_mobile_form();
    }

    const form_load = () => {
        // Check values and focus in inputs
        $(`${moduloId} form input[type=text]`).each(function(index, elem){

            if ( $(elem).val().trim() === '' && !$(elem).is(':focus')  ) {
                $(elem).prev().removeClass('active-label');
            }
        });
    }

    const apply_jquery_mask = () => {
        if (typeof $.fn.mask !== "undefined") {
            $(`${moduloId} form #telefone`).mask("(00) 00000-0000");
            $(`${moduloId} form #cpf`).mask("000.000.000-00");
        }
    }

    const on_form_submit = () => {
        $(`${moduloId} form`).on("submit", function () {
            let amplitudeTrack = $(this).data('amplitudetrack');

            if (amplitudeTrack) {
                const action = $(this).attr('action') + '&utm_test=abTestLPInteressePLP_v2_control';
                $(this).attr('action', action);

                const urlorigin = $(this).attr('data-urlorigin') + '&utm_test=abTestLPInteressePLP_v2_control';
                $(this).attr('data-urlorigin', urlorigin);
            }

            const formData = prepare_formdata();

            let funcSend = $(this).data('funcsend');
            funcSend = funcSend ? funcSend : 'send_api_pravaler';

            if ( validation_inputs(formData) ) {
                if ( isCkbChecked('termos-aceite-uso') )

                    if (amplitudeTrack) {
                        amplitude.track({
                            event_type: "clicked_simular_form_lead", 
                            event_properties: {
                                'page-path': window.location.pathname,
                            },
                          }).promise.then(function() {
                            eval(funcSend)(formData);
                        });
                    } else {
                        eval(funcSend)(formData);
                    }

            } else {
                error_handle_bubble(
                    'button-submit',
                    'Preencha todo o formulário e aceite nossas Políticas de Privacidade antes de prosseguir!'
                );
            }

            return false;
        });
    }

    const prepare_formdata = () => {
        let formData = new FormData();
        
        $(`${moduloId} form input`).each( function(index, field) {
            let fieldValue = field.value;

            // fields[type=number]
            if (field.getAttribute('data-maskType') === 'number') {
                fieldValue = fieldValue.replace(REGEXP_CLEAR_NUMBERS, "");
            }

            // fields[type=checkbox]
            if (field.getAttribute('type') === 'checkbox') {
                fieldValue = document.getElementById( 
                    field.getAttribute('id') ).checked ? true : false;
            }

            formData.append(
                field.getAttribute('id'),
                fieldValue
            );
        });

        return formData;
    }

    const reset_form = (formData) => {
        for (const field of formData.entries()) {
            let elem =  $(`${moduloId} form input#${field[0]}`);

            if (elem.attr('type') === 'text') {
                elem.val('');
                $(`${moduloId} form label[for="${field[0]}"]`).removeClass('active-label');
            }
        }
    }

    const send_api_pravaler = (formData) => {
        let xhttp = new XMLHttpRequest();
        xhttp.responseType = WP_AJAX_RESPONSE_TYPE;

        if (!navigator.onLine) {
            error_handle_bubble(
                'whatsapp',
                'Você está desconectado. Verifique sua conexão e tente novamente.'
            );
        }else{

            let form = $(`${moduloId} form`);
            let url = createUrlWithUtms('button-submit', form.attr('data-urlorigin'))
            formData.append('url_origem', url);

            xhttp.onreadystatechange = function () {
                if (this.readyState === 4) {
                    if (this.status === 200) {
                        if (xhttp.response.token === undefined) {
                            error_handle_bubble(
                                'whatsapp',
                                'Estamos com problema de instabilidade! <br><br> Tente novamente mais tarde ou <a href="#">faça a simulação clicando aqui</a>.'
                            );
                            return false;
                        }
                        
                        const urlAction = utmsUrlToken('button-submit', `${form.attr('action')}/?token=${xhttp.response.token}`)

                        let url_redirect = `${urlAction}`;
    
                        formData.delete('url_origem');
                        reset_form(formData);

                        window.location.href = url_redirect;
                    } else {
                        error_handle_bubble(
                            'whatsapp',
                            'Estamos com problema de instabilidade! Tente novamente mais tarde ou <a href="#">faça a simulação clicando aqui</a>.'
                        );
                    }
                }
            };
    
            formData.append('action', WP_AJAX_ACTION);
            xhttp.open(WP_AJAX_METHOD, WP_AJAX_ROUTE, true);
            xhttp.send(formData);
        }
    }

    const send_api_yduqs = (formData) => {
        let xhttp = new XMLHttpRequest();
        xhttp.responseType = WP_AJAX_RESPONSE_TYPE;

        xhttp.onreadystatechange = function () {
            if (this.readyState === 4) {
                if (this.status === 200) {

                    if (xhttp.response.status === 'error') {
                        error_handle_bubble(
                            'whatsapp',
                            xhttp.response.message
                        );
                        return false;
                    }

                    reset_form(formData);

                    $('#modal-yduqs').css('display', 'none');
                    $('#modal-yduqs-success').css('display', 'flex');
                } else {
                    error_handle_bubble(
                        'whatsapp',
                        'Estamos com problema de instabilidade! <br><br> Tente novamente mais tarde ou entre em contato conosco pelo CHAT.'
                    );
                }
            }
        };

        formData.append('action', 'save_data_student_yduqs');
        xhttp.open(WP_AJAX_METHOD, WP_AJAX_ROUTE, true);
        xhttp.send(formData);
    }

    const error_handle_bubble = (id, message) => {
        let target = $(`${moduloId} form #${id}`).position();

        let html = `<div class="error-general-bubble" style="top: ${target.top - 60}px">${message}</div>`;

        $(`${moduloId} form div.error-general-bubble`).remove();
        $(`${moduloId} form`).append(html);
    }

    const apply_click_out_bubble = () => {
        $(`${moduloId} form *`).on('click', function() {
            $(`${moduloId} form div.error-general-bubble`).remove();
        });
    }

    const validation_inputs = (formData) => {
        let formIsValidate = true;

        for (const field of formData.entries()) {

            $(`${moduloId} form input#${field[0]}`).parent().removeClass('field-error');
            $(`${moduloId} form input#${field[0]}~p`).remove();        
            
            try {
                if (field[1].trim() == "") {
                    throw {
                        id: field[0]
                    };

                } else {
                    let funcValidate = $(`${moduloId} form input#${field[0]}`).data('funcvalidate');
                    switch(funcValidate) {
                        case 'isNameFull': 
                            isNameFull(field[0], field[1]);
                            break;
                        case 'isEmail': 
                            isEmail(field[0], field[1]);
                            break;
                        case 'isCellFull': 
                            isCellFull(field[0], field[1]);
                            break;
                        case 'isCPF': 
                            isCPF(field[0], field[1]);
                            break;
                    }
                }

            } catch(e) {
                $(`${moduloId} form input#${e.id}`).parent().addClass('field-error');

                if (typeof e.message != 'undefined') {
                    $(`${moduloId} form input#${e.id}`)
                        .after(`<p class="msg-error">${e.message}</p>`);
                }

                formIsValidate = false;
            }
        }

        return formIsValidate;
    }

    const isNameFull = (id, value) => {
        value = value.trim();
        if (!REGEXP_NAME_FULL.test(value)) 
            throw {
                id: id,
                message: $(`${moduloId} form input#${id}`).data('msgerror')
            };
    }

    const isEmail = (id, value) => {
        value = decodeURIComponent(value);
        value = value.trim();
        if (!REGEXP_EMAIL.test(value))
            throw {
                id: id,
                message: $(`${moduloId} form input#${id}`).data('msgerror')
            };
    }

    const isCellFull = (id, value) => {
        value = value.trim();
        if (value.length !== 11) 
            throw {
                id: id,
                message: $(`${moduloId} form input#${id}`).data('msgerror')
            };
    }

    const isCPF = (id, value) => {
        let isValid = true;
        let s=0,r;
        value = value.replace(/[^0-9]/g, "");
        if(value==="00000000000") isValid = false;
        for(let i=1;i<=9;i++)s=s+parseInt(value.substring(i-1,i), 10)*(11-i);
        r=(s*10)%11;
        if((r===10)||(r===11)) r=0;
        if(r!=parseInt(value.substring(9,10), 10)) isValid = false;
        s=0;
        for(let i=1;i<=10;i++)s=s+parseInt(value.substring(i-1,i), 10)*(12-i);
        r=(s*10)%11;
        if((r===10)||(r===11))r=0;
        if(r!=parseInt(value.substring(10, 11), 10)) isValid = false;
        
        if (!isValid)
            throw {
                id: id,
                message: $(`${moduloId} form input#${id}`).data('msgerror')
            };
    }

    const isCkbChecked = (id) => {
        if ( $(`${moduloId} form input#${id}`).is(':checked') ) {
            return true;

        } else {
            error_handle_bubble(id, $(`${moduloId} form input#${id}`).data('msgerror'));
            return false;
        }
    }

    const activeLabelsAndFields = () => {

        $(`${moduloId} form input[type=text]`).on(`focusin`, function() {
            $(this).prev().addClass('active-label');
        });

        $(`${moduloId} form input[type=text]`).on(`focusout`, function() {

            if ( $(this).val().trim() === "" ) {
                $(this).prev().removeClass('active-label');
            } else {
                $(this).prev().addClass('active-label');
            }
        });
    }

    const nav_mobile_form = () => {

        $('#btn-show-form-interesse').on('click', function() {
            $('#bloco-lead-form').fadeIn();
        });

        $(`${moduloId} #close-button-mobile`).on('click', function() {
            $('#bloco-lead-form').fadeOut();
        });
    }

    return {
        init: init
    }
})();
$(document).ready(form_lead_interesse.init);